import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Sidebar from './Sidebar';
import { getShowSidebar } from 'store/sidebar/selectors';
import { showSidebar, hideSidebar } from 'store/sidebar/actions';
import { openHelpDialog } from 'store/dialogs/actions';
import { getLanguage } from 'store/language/selectors';
import { setLanguage } from 'store/language/actions';
import { getPersistentSidebar } from 'store/browser/selectors';
import { getWishesFiltersChecked } from 'store/wishes/selectors';
import { getIsAdmin } from 'store/firebase/selectors';
import { toggleFilter } from 'store/wishes/actions';

const mapStateToProps = createSelector(
  getShowSidebar,
  getLanguage,
  getPersistentSidebar,
  getWishesFiltersChecked,
  getIsAdmin,
  (showSidebar, language, persistentSidebar, checked, isAdmin) => ({
    showSidebar,
    language,
    persistentSidebar,
    checked,
    isAdmin
  })
);

const actions = dispatch => ({
  onShowSidebar: () => {
    dispatch(showSidebar());
  },
  onHideSidebarClicked: () => {
    dispatch(hideSidebar());
  },
  onHelpClicked: () => {
    dispatch(openHelpDialog());
  },
  onLanguageClicked: language => {
    dispatch(setLanguage(language));
  },
  onFilterToggle: name => {
    dispatch(toggleFilter(name));
  }
});

export default connect(mapStateToProps, actions)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js